import { parseNumber } from 'libphonenumber-js';
import parseMax from 'libphonenumber-js/max';

const PHONE_TYPES = { MOBILE: 'mobile', LANDLINE: 'landline' };

class PhoneNumber {
  constructor(countryCode, number, requiredType = null, australianOnly = true) {
    if (requiredType && !Object.values(PHONE_TYPES).includes(requiredType)) {
      console.error('This phone type is not supported:', requiredType);
      return;
    }

    this.requiredType = requiredType;
    this.australianOnly = australianOnly;

    this.setNumber(countryCode, number);

    console.log(this);
  }

  isValid() {
    return !!this.formattedNumber;
  }

  setNumber(countryCode, number) {
    this.raw = {
      countryCode,
      number,
    };

    try {
      this.setFormattedPhoneNumber();
    } catch (e) {
      console.error('ERROR while formatting a phone number ', e);
      this.resetFormattedPhoneNumber();
    }
  }

  setFormattedPhoneNumber() {
    const formatted = this.format();

    if (!formatted) {
      this.resetFormattedPhoneNumber();
      return;
    }

    const { formattedNumber, phoneType, isAustralian } = formatted;

    this.formattedNumber = formattedNumber;
    this.type = phoneType;
    this.isAustralian = isAustralian;
  }

  resetFormattedPhoneNumber() {
    this.formattedNumber = null;
    this.type = null;
    this.isAustralian = undefined;
  }

  format() {
    if (!this.raw.number) {
      return null;
    }

    const isAustralian = this.australianOnly || this.isAustralianCountryCode();

    return isAustralian ? this.formatAuPhoneNumber() : this.formatInternationalPhoneNumber();
  }

  isAustralianCountryCode() {
    const countryCode = this.raw.countryCode;
    return countryCode === '+61' || countryCode === '61';
  }

  isRequiredType(phoneType) {
    if (!this.requiredType) return true;

    return phoneType === this.requiredType;
  }

  formatAuPhoneNumber() {
    if (!this.raw.number) return null;

    let pn = parseNumber(this.raw.number, 'AU');
    const pnType = parseMax('+61' + pn.phone)?.getType();

    if (!pnType) return null;

    const phoneType = pnType === 'MOBILE' ? PHONE_TYPES.MOBILE : PHONE_TYPES.LANDLINE;

    if (!this.isRequiredType(phoneType)) {
      console.error(`This number is NOT ${this.requiredType}.`);
      return null;
    }

    return {
      formattedNumber: `0${pn.phone}`,
      phoneType: phoneType,
      isAustralian: true,
    };
  }

  // TODO: Add more sophisticated logic here.
  formatInternationalPhoneNumber() {
    const { countryCode, number } = this.raw;

    if (!countryCode || !number) return null;

    const fullNumber = (countryCode + number).replaceAll(' ', '');

    // Allow +, -, and digits only
    const re = /[+\-\d]$/i;
    if (!re.test(fullNumber)) return null;

    return {
      formattedNumber: fullNumber,
      type: undefined,
      isAustralian: false,
    };
  }
}

export { PHONE_TYPES, PhoneNumber };
